import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ContainedButton, defaultImage, EmptyPage, LargeText } from '@guryou/html-components';
import { Box, Checkbox, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 50px)',
    marginTop: '50px',
    padding: theme.spacing(3),
    backgroundColor: '#212121',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  headerRow: {
    color: '#ccc',
    display: 'flex',
    padding: '12px',
    borderBottom: '1px solid #444',
    backgroundColor: '#2a2a2a',
    fontWeight: 'bold',
  },
  row: {
    color: '#ccc',
    '& *': {
      color: '#ccc !important',
    },
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    borderBottom: '1px solid #444',
    '&:hover': {
      backgroundColor: '#2e2e2e',
    },
  },
  col: {
    padding: '0 8px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  flexCol2: {
    flex: 2,
  },
  flexCol: {
    flex: 1,
  },
  controls: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
  },
}));

const CircuitsView = ({ open }) => {
  const history = useHistory();
  const classes = useStyles();
  const [circuits, setCircuits] = useState({ loading: true, data: [] });

  useEffect(() => {
    const fetchCircuits = async () => {
      const query = `
        query GetCircuits {
          circuits {
            id
            title
            description
            is_public
            provider_id
          }
        }
      `;

      try {
        const response = await fetch('https://1ccbrgd0eh.execute-api.eu-west-1.amazonaws.com/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            query,
          }),
        });

        const result = await response.json();

        if (result.errors) {
          console.error('Error fetching circuits:', result.errors);
          setCircuits({ loading: false, data: [], error: 'Failed to fetch circuits' });
        } else {
          setCircuits({ loading: false, data: result.data.circuits });
        }
      } catch (error) {
        console.error('Error fetching circuits:', error);
        setCircuits({ loading: false, data: [], error: 'Failed to fetch circuits' });
      }
    };

    fetchCircuits();
  }, []);

  if (circuits.loading) {
    return <div>Loading...</div>;
  }

  return (
    <main
      className={clsx(classes.content, {
        [classes.contentShift]: open,
      })}
    >
      <Box className={classes.controls}>
        <ContainedButton color="secondary" onClick={() => history.push('/guryou-ai-studio/circuits/create')}>
          Create Circuit
        </ContainedButton>
      </Box>

      <Box className={classes.headerRow}>
        <div className={clsx(classes.col, classes.flexCol2)}>Title</div>
        <div className={clsx(classes.col, classes.flexCol2)}>Description</div>
        <div className={clsx(classes.col, classes.flexCol)}>Actions</div>
      </Box>

      <div style={{ overflow: 'auto' }}>
        {circuits.data?.length > 0 ? (
          circuits.data.map(ex => (
            <Box key={ex.id} className={classes.row}>
              <div className={clsx(classes.col, classes.flexCol2)}>
                <Typography variant="body1" style={{ fontWeight: 600 }}>
                  {ex?.title || 'No title found'}
                </Typography>
              </div>
              <div className={clsx(classes.col, classes.flexCol2)}>{ex.description}</div>
              <div className={clsx(classes.col, classes.flexCol)}>
                <ContainedButton color="primary" size="small">
                  Edit
                </ContainedButton>
              </div>
            </Box>
          ))
        ) : (
          <EmptyPage>
            <LargeText color="white">No circuits found.</LargeText>
          </EmptyPage>
        )}
      </div>
    </main>
  );
};

export default CircuitsView;
